import React from "react";
import Navbar from "../componentes/Navbar/Navbar";
import LoginButton from "../componentes/Auth/Login/LoginButton";

const Home =  () => {
    return(
        <div className="flex  gap-5 flex-col p-10 h-screen items-center justify-start bg-gray-100">
            <h1 className="text-4xl font-bold">Bem vindo ao SIC</h1>
            <div>
            <LoginButton/>
            </div>
        </div>
    )
}

export default Home